import config from 'src/config'
import store from 'src/store'
import { LOGIN_PATH } from 'src/router/auth'

export const DEFAULT_SCREENS_VERSIONS = {
  'log': 'old',
  'disciplineRules.list': 'new',
  'disciplineRules.new': 'new',
  'position-rules': 'new',
  'timeoff.list': 'new',
  'timeoff.new': 'new',
  'calcs.list': 'old',
  'calcs.new': 'old',
  'dados': 'new',
  'permissions.list': 'new',
  'permissions.new': 'new',
  'reports': 'new',
  'gerenciamento-banco': 'new',
  'activity-manager': 'new',
  'devices-management': 'new',
  'notificationRules.list': 'new',
  'notificationRules.new': 'new',
  'extraTimeDashboard': 'new',
  'workSchedule': 'new',
  'monitor-entrance': 'new',
  'monitor-workplace': 'new',
  'event-log': 'old',
  'move-employee-position': 'old',
  'movement-log': 'old',
  'position-plan': 'old',
  'timesheet': 'new',
  'verifyTimesheet': 'new',
  'locker-management': 'new',
  'mass-changes': 'new',
  'employee.list': 'new',
  'employee.all': 'new',
  'employee.new': 'new',
  'company.new': 'new',
  'company.list': 'new',
  'employer.new': 'new',
  'employer.list': 'new',
  'user-group': 'new',
  'workjourney': 'new',
  'routine.list': 'new',
  'routine.new': 'new',
  'holidays': 'new',
  'reason.list': 'new',
  'reason.new': 'new',
  'activity-type': 'new',
  'activity-cost-center': 'new',
  'activity': 'new',
  'Integration': 'old',
  'whb-management': 'new',
  'user.edit': 'new'
}

export function renderIframeForRoute (router, route) {
  // TODO UPDATE THE HASH OF IFRAME TOO

  const iframe = document.getElementById('the_iframe')

  if (route.name === 'Integration' || DEFAULT_SCREENS_VERSIONS[route.name] === 'old') {
    iframe.style.display = 'block'
    document.getElementById('view-space').style.display = 'none'
    iframe.contentWindow.postMessage(JSON.stringify({path: router.currentRoute.path}), '*')
  } else {
    iframe.style.display = 'none'
    document.getElementById('view-space').style.display = 'block'
  }
}

export function putIframeInEmptyRoute () {
  const iframe = document.getElementById('the_iframe')
  iframe.contentWindow.postMessage(JSON.stringify({hideAll: true}), '*')
}

export function updateOrCreateIframeIntegration (router, to) {
  const iframe = document.getElementById('the_iframe')

  // only load iframe if user is signedin or if iframe has already been created
  if (store.state.userInfo?.id || iframe.src) {
    // activate the angular iframe if we didnt do yet
    if (!iframe.src) {
      if (to.path !== '/' && DEFAULT_SCREENS_VERSIONS[to.name] !== 'old') {
        iframe.src = config.iframeUrl + '#/empty-route'
      } else {
        iframe.src = window.location.hash.includes(LOGIN_PATH) ? config.iframeUrl : config.iframeUrl + window.location.hash
      }
    }

    if (to.name !== 'Integration' && DEFAULT_SCREENS_VERSIONS[to.name] !== 'old') {
      putIframeInEmptyRoute()
    } else {
      iframe.contentWindow.postMessage(JSON.stringify({name: to.name, path: to.path}), '*')
    }

    router.renderIframeForRoute(to)
  }
}

export function startToListenForIframeMessage (router) {
  window.addEventListener('message', function (e) {
    if (e.data === 'needTologinAgain') {
      window.location.href = window.location.origin + '/#' + LOGIN_PATH
    }

    try {
      if (e.data.slice) {
        const data = JSON.parse(e.data)

        if (data.redirectUrl && data.redirectUrl !== '#/empty-route') {
          router.push(data.redirectUrl.slice(1))
        } else if (data.useNewVersionOf) {
          router.go()
        }
      }
    } catch (e) {
    }
  })
}
